import Controller from '../abstracts/Controller';
import 'scss-templates/t-wishlist.scss';

export default class WishlistController extends Controller {
  static get COMPONENTS() {
    return [
        'WishlistComponent',
        'MyAccountNavigationComponent',
        'RecommendationEngineComponent',
        'AddToCartComponent',
        'SizeSelectorComponent',
        'NotifyMeComponent'
    ];
  }
}
